import { createContext as e, useContext as o } from "react";
const s = e(
  null
), r = {
  selectedItems: [],
  // 已選擇的影片
  setSelectedItems: (t) => {
  },
  // 已選擇的影片 setter
  limit: 1,
  // 能選擇的影片數量
  uploadProps: {},
  // 上傳影片的屬性
  tabsProps: {}
  // 標籤頁的屬性
}, c = () => {
  const t = o(s);
  return {
    ...r,
    ...t
  };
};
export {
  s as MediaLibraryContext,
  c as useProps
};
